/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DrugbankRXNorm
 */
export interface DrugbankRXNorm {
    /**
     * 
     * @type {string}
     * @memberof DrugbankRXNorm
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof DrugbankRXNorm
     */
    RXCUI?: string;
}

/**
 * Check if a given object implements the DrugbankRXNorm interface.
 */
export function instanceOfDrugbankRXNorm(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DrugbankRXNormFromJSON(json: any): DrugbankRXNorm {
    return DrugbankRXNormFromJSONTyped(json, false);
}

export function DrugbankRXNormFromJSONTyped(json: any, ignoreDiscriminator: boolean): DrugbankRXNorm {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'RXCUI': !exists(json, 'RXCUI') ? undefined : json['RXCUI'],
    };
}

export function DrugbankRXNormToJSON(value?: DrugbankRXNorm | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'RXCUI': value.RXCUI,
    };
}

